const DEFAULT_RETURN_PATH = "/";

export function sanitizeReturnTo(input: string | null | undefined): string {
  if (typeof input !== "string") {
    return DEFAULT_RETURN_PATH;
  }

  const trimmed = input.trim();
  if (trimmed.length === 0) {
    return DEFAULT_RETURN_PATH;
  }

  if (!trimmed.startsWith("/")) {
    return DEFAULT_RETURN_PATH;
  }

  if (trimmed.startsWith("//")) {
    return DEFAULT_RETURN_PATH;
  }

  if (trimmed.includes("://")) {
    return DEFAULT_RETURN_PATH;
  }

  if (trimmed.includes("\0")) {
    return DEFAULT_RETURN_PATH;
  }

  return trimmed;
}





